const unidades = [
  "",
  "uno",
  "dos",
  "tres",
  "cuatro",
  "cinco",
  "seis",
  "siete",
  "ocho",
  "nueve",
];
const decenas = [
  "",
  "diez",
  "veinte",
  "treinta",
  "cuarenta",
  "cincuenta",
  "sesenta",
  "setenta",
  "ochenta",
  "noventa",
];
const especiales = [
  "diez",
  "once",
  "doce",
  "trece",
  "catorce",
  "quince",
  "dieciséis",
  "diecisiete",
  "dieciocho",
  "diecinueve",
];
const centenas = [
  "",
  "ciento",
  "doscientos",
  "trescientos",
  "cuatrocientos",
  "quinientos",
  "seiscientos",
  "setecientos",
  "ochocientos",
  "novecientos",
];

function numToWords(n: number): string {
  if (n === 0) return "cero";
  if (n < 0) return `menos ${numToWords(-n)}`;
  if (n < 10) return unidades[n];
  if (n < 20) return especiales[n - 10];
  if (n < 100) {
    const d = Math.floor(n / 10);
    const u = n % 10;
    return decenas[d] + (u > 0 ? ` y ${unidades[u]}` : "");
  }
  if (n < 1000) {
    const c = Math.floor(n / 100);
    const rest = n % 100;
    if (n === 100) return "cien";
    return centenas[c] + (rest > 0 ? ` ${numToWords(rest)}` : "");
  }
  if (n < 1000000) {
    const mil = Math.floor(n / 1000);
    const rest = n % 1000;
    const milText = mil === 1 ? "mil" : `${numToWords(mil)} mil`;
    return milText + (rest > 0 ? ` ${numToWords(rest)}` : "");
  }
  return "";
}

export const amountToWordsEs = (amount: number): string => {
  const dollars = Math.floor(amount);
  const cents = Math.round((amount - dollars) * 100);

  let words = numToWords(dollars);
  if (dollars === 1) {
    words = "un";
  }

  const centsText = cents.toString().padStart(2, "0");
  const result = `${words} con ${centsText}/100`;
  return result.charAt(0).toUpperCase() + result.slice(1);
};
